import React from "react";

const AirTreatment = () => {
  return (
    <div className="bg-gray-10 p-2 flex flex-col max-w-[464px] ">
      <p className="text-teal-300 text-left text-body-sm  font-normal">
        Humidifiers are used to add moisture to the air when it is dry. Humidity
        promotes mite growth.
      </p>
    </div>
  );
};

export default AirTreatment;
